module.exports = __webpack_public_path__ + "img/logo.21bf62ca.png";